import React from 'react';
import classNames from 'classnames';
import { IABSLabelValueData } from './interface';
import './ABSLabelValue.less';

export interface IABSLabelValueProps {
  item: IABSLabelValueData;
  labelValueTitleMinWidth: number;
}

class ABSLabelValue extends React.Component<IABSLabelValueProps> {
  
  renderContent() {
    const { item } = this.props;
    const { contentStyle, content = '' } = item;
    if (typeof content === 'string') { // 保留富文本格式
      return <p className="abs-label-value-content" dangerouslySetInnerHTML={{ __html: content }} style={contentStyle} />;
    }
    return <div className="abs-label-value-content" style={contentStyle}>{content}</div>;
  }

  render() {
    const { item, labelValueTitleMinWidth } = this.props;
    const { isMultiLines, title } = item;
    const content = item && item.content;
    const isLines = typeof content === 'string' && /<br>|<br\/>|<br \/>/.test(content as string) || isMultiLines ;
    const classes = classNames('abs-label-value', {
      'abs-label-value-multi-line': isLines,
    });
    return (
      <div className={classes}>
        {title ? <p className="abs-label-value-title" style={{ minWidth: labelValueTitleMinWidth }} >{item.title}</p> : null}
        {this.renderContent()}
      </div>
    );
  }
}
export { IABSLabelValueData };
export default ABSLabelValue;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSLabelValueList/ABSLabelValue.tsx